export default __webpack_public_path__ + "static/media/altitude.557ab7d3.svg";